import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  en: {
    translation: {
      ...require("./locales/en.json"),
      ...require("./locales/marketing.en.json"),
    },
  },
  fr: {
    translation: {
      ...require("./locales/fr.json"),
      ...require("./locales/marketing.fr.json"),
    },
  },
  de: {
    translation: {
      ...require("./locales/gr.json"),
      ...require("./locales/marketing.gr.json"),
    },
  },
  es: {
    translation: {
      ...require("./locales/sp.json"),
      ...require("./locales/marketing.sp.json"),
    },
  },
  nl: {
    translation: {
      ...require("./locales/nl.json"),
      ...require("./locales/marketing.nl.json"),
    },
  },
  pt: {
    translation: {
      ...require("./locales/pt.json"),
      ...require("./locales/marketing.pt.json"),
    },
  },
};
const DEFAULT_LANGUAGE = "en";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem("i18nextLng") || localStorage.getItem("lng") || DEFAULT_LANGUAGE, // Saved preference (both keys for compatibility)
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
